module.exports = {"title":"De trap van de cinematografie","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"Filmanalyse schema.pdf","linktext":"Lees het schema voor filmanalyse en filmgesprek","body":"<p>Dit document bevat <strong>het schema voor filmanalyse en filmgesprek</strong>, dat Sylvain De Bleeckere ontwikkelde. Het betreft een bewerking van een schema waarvan de eerse aanzet is gepubliceerd in <strong>Leren Leven Met Beelden</strong> nr. 2 (1996).</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/2015-01-06-TrapCinematografie/index.md
// module id = 968
// module chunks = 0